

























import { Vue, Component } from "vue-property-decorator";
import Map from "@/components/map/Map";
import { User } from "@/components/User";
import { Extent } from "@/components/map/types";
import { IDialog } from "@/components/shared/types";
import MapUI from "@/components/map/MapUI.vue";
import DialogUI from "@/components/shared/DialogUI.vue";

@Component({
  components: {
    'ol-map': MapUI,
    'v-dialog': DialogUI
  }
})
export default class DoaeMap extends Vue {
  $map: Map = null; 
  mapExtent:Extent = [100.8, 14.0, 101.0, 14.2];
  activeBaseMap: string = 'gistda.thaichote';
  hasLand: boolean = false;

  get Dialog() : IDialog {
    return this.$store.getters.Dialog;
  }

  get User() : User {
    return this.$store.getters.User;
  };

  getURLParameter(name:string) : string {
    let value = RegExp(name + '=(.+?)(&|$)').exec(location.search);
    return value ? decodeURI(value[1]) : null;
  }

  created() {
  };

  async mounted() {
    let activityId = null;
    let gid = null;
    try {
      let id = this.getURLParameter('id');
      if (id) {
        [activityId,gid] = id.split(',');
        this.hasLand = true;
        if (gid) {
          let land = await this.User.requestResource('gis/farmland/' + gid);
          let features = this.$map.GeoJSONToFeatures(land, {
            dataProjection: 'EPSG:4326',
            featureProjection: 'EPSG:3857'
          });
          this.$map.addFeaturesToLayer(features,'AoiLayer', {
            resetMapExtent: true,
            zoomTo: true
          });
        }
      }
    } catch (error) {
      this.hasLand = false;
      let e = error;
      console.log(e);
      if (error.id.match(/no_content|not_found/)) {
        this.$store.commit('notifyChange', {
          Dialog: {
            Type: 'info',
            Title: 'attention',
            Message: 'ไม่มีข้อมูลแปลงที่เชื่อมโยงกับ ACTIVITY_ID: ' + activityId,
            OkText: null,
            CancelText: 'close',
            show: true,
            OnClose: null
          }
        });
      } else {
        this.$store.commit('notifyChange', {
          Dialog: {
            Type: 'error',
            Title: 'error',
            Message: error.message || 'Opps! We have encounted error when create map for DOAE. Please contact our system admin.',
            OkText: null,
            CancelText: 'close',
            show: true,
            OnClose: null
          }
        });
      };
    }
  };

  beforeDestroy() {
  };

  onMapCreated(map:Map) {
    this.$map = map; 
  };

  closeDialog(result:"ok" | "cancel" | "close") {
    let OnClose = this.Dialog.OnClose;
    let close;
    if (OnClose) {
      close = OnClose(result);
    }
    this.$store.commit('notifyChange', {
      Dialog: {
        //Type: 'info',
        show: close===false,
        wait: false
      }
    });
  };
}
